export const LAYOUT_PX: [string, string, string] = ['16px', '32px', '160px'];
